const styles = (theme) => ({
    root: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '33.33%',
        flexShrink: 0,
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
    tableInitialSummary: {
        borderLeft: `5px solid ${theme.palette.secondary.main}`,
    },
    borderNone: {
        border: 'none',
    },
    summaryTitle: {
        fontSize: '12px',
        margin: '0',
    },
    summarySubtitle: {
        fontSize: '14px',
        margin: '0',
    },
    summaryInfoSubtitle: {
        margin: '0',
        color: '#666',
    },
});

export default styles;
